import { type Common } from './common.js';
import {
  type FeedMessage,
  type FindAllOptions,
  type SafeFeedMessage,
} from './models/feedMessage.js';
import { isTruthy } from './utils.js';

export class API {
  common: Common;
  baseEndpoint = 'feeds';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(query?: FindAllOptions): Promise<SafeFeedMessage[]> {
    const { feedId, ...findAllQuery } = query ?? {};
    if (!isTruthy(feedId)) {
      throw Error('Feed Id is required');
    }
    const url = this.common.constructPath(`${this.baseEndpoint}/${feedId}/messages`, findAllQuery);
    return await this.common.getJSON(url);
  }

  async findOneById(feedId: string, messageId: string): Promise<FeedMessage> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${feedId}/messages/${messageId}`);
    return await this.common.getJSON(url);
  }
}
